<template>
	<div class="contarin">
	   <div class="firstBg fsFLex">
		   <div class="fdix">
			   <div class="f1">全渠道客服系统</div>
			   <div class="f2">
				   多平台｜多语言实时翻译 跨境出海工具
			   </div>
			   <div class="freeBtn" @click="toRegister">
				   免费试用
			   </div>
		   </div>
		   <div class="imagebg">
			   <img src="../assets/img/firstR.svg" />
		   </div>
	   </div>
	   <div class="secondBg">
		   <div class="tlBt">10,000+ 企业客户</div>
		   <div class="tlDes">每天都在使用 青龙翻译器 并热爱着它！</div>

		   <div class="secondItem">
			   <div class="iiitem">
				   <div>10k+</div>
				   <div>公司选择我们</div>
			   </div>
			    <div class="iiitem">
				   <div>10m+</div>
				   <div>客户聊天</div>
			   </div>
			    <div class="iiitem">
				   <div>50m+</div>
				   <div>发送的消息</div>

			   </div>
		   </div>
	   </div>

	   <div class="whyChose">

		   <div class="whyChoseTl">
			   为什么选择青龙翻译器?
		   </div>

		 <div  style="justify-content: center; display: flex;gap: 46px;">

			  <div class="whyChoseItem">

			  		<img src="../assets/img/whychose1.svg"/>
			  			     <p>倾听您的声音</p>

			  			   <div>
							   您对青龙翻译器 任何的建议我们都会认真听 取并且反馈。
						   </div>

			  </div>
			  <div class="whyChoseItem">

			  			   <img src="../assets/img/whychose2.svg"/>

			  			   <p>强大的产研团队</p>

			  			   <div>
			  			   		 诚挚地邀请在专业领域表现出色的人才加入 并实现我们的共同愿景。
			  			   </div>
			  </div>
			  <div class="whyChoseItem">

			  				<img src="../assets/img/whychose3.svg"/>
			  			   	   <p>贴心的服务</p>
			  			   <div>
			  			   			我们的全球团队随时准备在您需要时提供帮 助。
			  			   </div>

			  </div>


		  </div>

	   </div>

		<div class="lanLocal">
			<div class="topDiv">
				<div class="lanLocalTl">
					语言<span style="color: #2ed36a;">本地化</span>消息
				</div>
				<div class="lanLocalDes">
					青龙翻译器客服系统已翻译全球<span>300多种语言</span>文字 让您可以轻松地用您的母语与客户聊天。
				</div>
				<div class="lanLocalBtn" @click="toRegister">免费注册</div>
			</div>

			<div class="mid">

				<div class="lanLocalTl">
					使用快捷方式
					<span style="color: #2ed36a;">快速响应</span>
				</div>
				<div class="lanLocalDes">
					借助青龙翻译器客服系统内置的知识库和方便的快捷 方式您每次都可以提供快速一致的响应。
				</div>
				<div class="lanLocalBtn"  @click="toRegister">免费注册</div>

			</div>


			<div class="btom">

				<div class="lanLocalTl">
					实时<span style="color: #2ed36a;">自动</span>翻译

				</div>
				<div class="lanLocalDes">
					AI智能即时翻译，精准识别多语言，接发消息自动 译文，<span>低于1毫秒的翻译响应</span>，让企业效率飞起！

				</div>
				<div class="lanLocalBtn"  @click="toRegister">免费注册</div>

			</div>

		</div>
		<!-- <div class="jiageTl">
			<span style="color: #2ed36a;">灵活定价</span>以应对业务扩展与您的业务一起成长
		</div>


		<div class="jiage">
			<div class="jiageItem">
				<div class="top">
					<div class="name">字符版</div>
					<div class="lable">适合个人</div>
				</div>
				<div class="content">
					<div class="tlName">
						100万<span>字符</span>
					</div>
					<div class="topayBtn">
						立即购买
					</div>
					<div class="des">不限子帐号 不限端口 字符共享</div>
					<div class="desList">
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							火山20U
						</div>

						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							微软20U
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							谷歌40U
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							Deepl 60U
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							不限窗口数量
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							不限使用时间
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							无限开子帐号
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							子帐号字符共享
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							多应用消息群发
						</div>
					</div>




				</div>
			</div>

			<div class="jiageItem">
				<div class="top">
					<div class="name">VIP版</div>
					<div class="lable">适合个人或团队出海</div>
				</div>
				<div class="content">
					<div class="tlName">
						$9<span>USDT/端口</span>
					</div>
					<div class="topayBtn">
						立即购买
					</div>
					<div class="des">不限字符 运营分析</div>
					<div class="desList il">
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							无限翻译字符
						</div>

						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							不限翻译路线
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							运营增长分析
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							窗口独立环境
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持独立配置IP
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持多设备登录
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							多应用消息群发
						</div>
						<div class="desItem">
							<img src="../assets/img/unselect.svg"/>
							AI智能生成回复
						</div>
						<div class="desItem">
							<img src="../assets/img/unselect.svg"/>
							支持语音翻译文字
						</div>
						<div class="desItem">
							<img src="../assets/img/unselect.svg"/>
							支持图片翻译文字
						</div>
						<div class="desItem">
							<img src="../assets/img/unselect.svg"/>
							ChatGPT纠正翻译
						</div>
					</div>




				</div>

			</div>

			<div class="jiageItem">
				<div class="top">
					<div class="name">SVIP版</div>
					<div class="lable">适合团队出海</div>
				</div>
				<div class="content">
					<div class="tlName">
							$13<span>USDT/端口</span>
					</div>
					<div class="topayBtn">
						立即购买
					</div>
					<div class="des">不限字符 全部功能可用</div>
					<div class="desList il">
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							无限翻译字符
						</div>

						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							不限翻译路线
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							运营增长分析
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							窗口独立环境
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持独立配置IP
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持多设备登录
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							多应用消息群发
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							AI智能生成回复
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持语音翻译文字
						</div>
						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							支持图片翻译文字
						</div>

						<div class="desItem">
							<img src="../assets/img/select.svg"/>
							ChatGPT纠正翻译
						</div>
					</div>


				</div>

			</div>

		</div> -->

		<div class="bottom">
			<img src="../assets/img/footer.jpg"/>

		</div>
	</div>
</template>

<script>
export default {
  methods: {
    // 新增首页回到顶部方法
    toHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
      window.document.body.querySelector('#app').scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    toPrice() {
      window.open(`https://download.${window.location.host}/price`, '_blank')
    },

    // 新增注册跳转方法
		toRegister () {
      window.open(`https://user.${window.location.host}/register`, '_blank')
    },

    // 新增下载跳转方法
    toDownload() {
      window.open(`https://download.${window.location.host}`, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
	.jiage{
		display: flex;
		justify-content: center;
		gap: 97px;
		margin: 114px 0;
		.jiageItem{
			box-sizing: border-box;
			width: 390px;
			min-width: 220Px;
			height: 791px;
			min-height: 660Px;
			background: #F8F9FA;
			box-shadow: 3px 4px 92px rgba(0, 0, 0, 0.08);
			border-radius: 32px;
			display: flex;
			flex-direction: column;
			.content{
				width: 100%;
				background: #FFFFFF;
				border-radius: 32px;
				flex: 1;
				box-sizing: border-box;
				padding-left: 36px;
				.desList{
					.desItem{
						margin-top: 16px;
						display: flex;
						align-items: center;
						font-family: 'PingFang HK';
						font-style: normal;
						font-weight: 500;
						font-size: 17px;
						line-height: 24px;

						color: #343F52;


						img{
							margin-right: 10px;
						}
					}
				}
				.il{
					.desItem{
						margin-top: 10px;
					}
				}
				.des{

					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 60px;
					color: #6A6A6A;


				}
				.topayBtn{
					width: 80px;
					height: 62.94px;
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 20px;
					line-height: 44.06px;
					text-align: center;
					color: #2ed36a;
					cursor: pointer;
					box-sizing: border-box;
					width: 318px;
					height: 44.06px;


					border: 1px solid #2ed36a;
					border-radius: 21px;
					&:hover{
						background-color: #2ed36a;
						color: #fff;
					}

				}
				.tlName{

					font-family: 'Quantico';
					font-style: normal;
					font-weight: 700;
					margin-top: 20px;
					line-height: 90px;
					font-size: 40px;
					color: #2ed36a;
					span{
						font-size: 25px;
					}

				}
			}
			.top{
				display: flex;
				justify-content: space-between;
				padding: 36px 40px;
				padding-bottom: 20px;
				.name{
					font-family: 'Quantico';
					font-style: normal;
					font-weight: 700;
					font-size: 24px;
					line-height: 34px;
					color: #4D4C5A;
				}
			.lable{
				padding: 0 14px;
				height: 30px;
				background: #A0F6E8;
				border-radius: 15px;
				text-align: center;
				line-height: 30px;
				font-family: 'Quantico';
				font-style: normal;
				font-weight: 400;
				font-size: 10px;
				color: #000000;

				}
			}
		}
	}

	.bottom{
		width: 100%;
		img{
			width: 100%;
		}
	}
	.jiageTl{
		font-family: 'Quantico';
		font-style: normal;
		font-weight: 700;
		font-size: 64px;
		line-height: 120%;
		width: 704px;
		margin:0 auto;
		text-align: center;
	}
	.lanLocal{
		 margin-top: 160px;
		 .lanLocalBtn{
			 cursor: pointer;
			 display: inline-block;
			 background: #2ed36a;
			 border-radius: 41.5px;
			 color: #FFFFFF;
			 padding: 14px 40px;
			 font-family: 'PingFang SC';
			 font-style: normal;
			 font-weight: 300;
			 font-size: 24px;
			 line-height: 120%;
			 margin-top: 80px;
		 }
		 .lanLocalTl{
			 font-family: 'Quantico';
			 font-style: normal;
			 font-weight: 700;
			 font-size: 64px;
			 line-height: 120%;
			 color: #4D4C5A;
		 }
		 .lanLocalDes{

			 font-family: 'PingFang HK';
			 font-style: normal;
			 font-weight: 400;
			 font-size: 32px;
			 line-height: 165%;
			 color: #4D4C5A;
			 width: 700px;
			 margin-top: 25px;
			 span{
				 background-color: #21EEC9;
				 font-weight: 500;
				 border-radius: 30px;
			 }
		 }
		.topDiv{
			padding: 210px 13%;
			padding-bottom: 0;
			background: url('../assets/img/localLans.svg') no-repeat;
			height: 722px;
		}
		.mid{
			padding: 210px 13%;
			padding-bottom: 0;
			background: url('../assets/img/fastRes.svg') no-repeat;
			height: 722px;
			background-position-x:100% ;
			text-align: right;
			.lanLocalDes{
				margin-left: auto;
			}
		}

		.btom{
			padding: 210px 13%;
			padding-bottom: 0;
			background: url('../assets/img/autoTran.svg') no-repeat;
			height: 722px;


		}

	}
	.whyChose{
		img{
			width: 79px;
			height: 71px;
		}
		.whyChoseItem{
			display: flex;
			flex-direction: column;
			width: 360px;
			// height: 294px;
			padding: 46px 36px;
			gap: 36px;
			background: #FFFFFF;
			box-shadow: 7px 4px 16.6px rgba(0, 0, 0, 0.08);
			border-radius: 48px;
			>p{

				font-family: 'PingFang SC';
				font-style: normal;
				font-weight: 600;
				font-size: 24px;
				line-height: 120%;
				color: #000000;

			}
			>div{
				font-family: 'PingFang SC';
				font-style: normal;
				font-weight: 300;
				font-size: 18px;
				line-height: 120%;
				display: flex;
				align-items: center;

				color: #000000;

			}

		}
		.whyChoseTl{

			font-family: 'Quantico';
			font-style: normal;
			font-weight: 700;
			font-size: 64px;
			line-height: 92px;

			text-align: center;
			letter-spacing: 0.06em;
			padding-top: 133px;
			color: #2ed36a;
			padding-bottom: 70px;
		}

		}
	.secondItem{
		margin-top: 80px;
		display: flex;
		gap: 20%;
		justify-content: center;
		.iiitem{
			>div{
				color: #21EEC9;
				font-family: 'Quantico';
				font-style: normal;
				font-weight: 400;
				font-size: 64px;
				line-height: 120%;
				&:last-of-type{
					color: #4D4C5A;
					font-size: 24px;
				}
			}
		}

	}
	.secondBg{
		background-color: #F8F9FA;
		height: 511px;
		.tlBt{
			padding-top: 96px;
			font-family: 'Quantico';
			font-style: normal;
			font-weight: 700;
			font-size: 48px;
			line-height: 120%;
			color: #4D4C5A;
			text-align: center;
		}
		.tlDes{
			font-family: 'Quantico';
			font-style: normal;
			font-weight: 400;
			font-size: 20px;
			line-height: 120%;
			text-align: center;
			color: #4D4C5A;
			margin-top: 12px;
		}
	}
	.firstBg{
    width: 100%;
		padding: 40px 55px;
		background: url('../assets/img/firstbg.svg') no-repeat;
		>div{
			flex: 1;
		}
    .imagebg > img {
      display: block;
      flex: 1;
      width: 100%;
      height: 100%;
    }
		.f1{
			color: #2ed36a;
			/* 全渠道客服系统 */
			font-family: 'Quantico';
			font-style: normal;
			font-weight: 700;
			font-size: 64px;
			line-height: 92px;
			letter-spacing: 0.06em;
			color: #2ed36a;
			width: 8em;

		}
		.f2{
			font-family: 'Quantico';
			font-style: normal;
			font-weight: 700;
			font-size: 48px;
			line-height: 120%;
			color: #4D4C5A;
			margin: 10px 0 100px 0;
		}
		.freeBtn{
			cursor: pointer;
			background: #2ed36a;
			border-radius: 42px;
			font-family: 'Quantico';
			font-style: normal;
			font-weight: 400;
			font-size: 36px;
			line-height: 51px;
			padding: 17px 60px;
			letter-spacing: 0.19em;
			display: inline-flex;
			color: #FFFFFF;
		}
	}
	.fdix{
		padding:0 180px  ;
	}
</style>
